// Core packages
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// Third party packages

// Custom packages - Misc
import { ArchiveV3RedirectGuard } from 'src/app/shared/guards/archive-v3-redirect.guard';
import { RoleGuard } from 'src/app/shared/guards/role.guard';
import { ARCHIVE_V3_DEADLINES } from 'src/app/shared/utils/archive-v3-redirect.utils';

// Custom packages - Component
import { DocumentsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/documents-deadlines-list/documents-deadlines-list.page';
import { NfcAccessSubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/nfc-access-subscriptions-deadlines-list/nfc-access-subscriptions-deadlines-list.page';
import { PrivacySagSubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/privacy-sag-subscriptions-deadlines-list/privacy-sag-subscriptions-deadlines-list.page';
import { PrivacySubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/privacy-subscriptions-deadlines-list/privacy-subscriptions-deadlines-list.page';
import { SubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/subscriptions-deadlines-list/subscriptions-deadlines-list.page';
import { SuppliersSubscriptionsDeadlinesListComponent } from 'src/app/modules/deadlines/pages/suppliers-subscriptions-deadlines-list/suppliers-subscriptions-deadlines-list.page';

const routes: Routes = [
  {
    path: 'list/subscriptions',
    component: SubscriptionsDeadlinesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: 'list/suppliers-subscriptions',
    component: SuppliersSubscriptionsDeadlinesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    // Opens deadlines-v3 instead once the 3.0.0 archive is live (FE-A1, ArchiveV3RedirectGuard); the
    // other deadline pages of this module stay as they are
    path: 'list/documents',
    component: DocumentsDeadlinesListComponent,
    canActivate: [ArchiveV3RedirectGuard, RoleGuard],
    data: {
      permissions: ['canReadDocumentsList'],
      archiveV3Redirect: ARCHIVE_V3_DEADLINES,
    },
  },
  {
    path: 'list/nfc-access-subscriptions',
    component: NfcAccessSubscriptionsDeadlinesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: 'list/privacy-subscriptions',
    component: PrivacySubscriptionsDeadlinesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: 'list/privacy-sag-subscriptions',
    component: PrivacySagSubscriptionsDeadlinesListComponent,
    canActivate: [RoleGuard],
    data: {
      permissions: ['canReadDocumentsList']
    },
  },
  {
    path: '**',
    redirectTo: 'it/errors/404'
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  exports: [
    RouterModule
  ]
})
export class DeadlinesRoutingModule { }
